<script setup lang="ts">
defineProps<{
  tag: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}>();
</script>

<template>
  <Component :is="tag" class="le-sikker-teknologi-heading">
    <slot />
  </Component>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";
@import "@fontsource/montserrat/700.css";

.le-sikker-teknologi-heading {
  margin: 0;
  color: #3075d1;
  font-family: Montserrat, sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 35px;

  #media-breakpoint-up(lg, {
    font-size: 44px;
    line-height: 60px;
  });
}
</style>
